import * as React from 'react';
import {PDF_MIME_TYPE} from '../../../../../common/constants/MimeTypeConstants';
import {DocumentModalViewProps} from '../../types/components';

class DocumentModalView extends React.Component<DocumentModalViewProps, {}> {

    render() {
        const {documentUrl, mimeType} = this.props;
        const isPDF: boolean = mimeType === PDF_MIME_TYPE;
        return (
            <div className="row justify-content-center">
                {isPDF &&
                <object data={`${documentUrl}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0`} width="400" height="800"/>}
                {!isPDF && <img className="img-fluid pb-3" src={documentUrl}/>}
            </div>
        );
    }
}

export default DocumentModalView;